import React from 'react';
import { useWriteFn } from 'apps/sigma2-ui/src/lib/hooks/useWriteFn';
import { useReadFn } from 'apps/sigma2-ui/src/lib/hooks/useReadFn';
import { useReadWritePattern } from 'apps/sigma2-ui/src/lib/hooks/useReadWritePattern';
import { S2SafeParsable } from 'libs/end-to-end/src/interfaces';

export const useSimpleReadWritePattern = <TRead, TWrite>({
  getReadUrlFn,
  getWriteUrlFn,
  writeSchema,
  canRead,
  canWrite,
  writeMethod,
  responseSchema,
}: {
  getReadUrlFn: () => string | null;
  getWriteUrlFn: () => string | null;
  writeMethod?: 'POST' | 'PUT';
  writeSchema: S2SafeParsable<unknown, TWrite>;
  responseSchema: S2SafeParsable<unknown, TRead>;
  canWrite: boolean;
  canRead: boolean;
}) => {
  const { isReadyToWrite, writeFn } = useWriteFn({
    getUrlFn: getWriteUrlFn,
    writeSchema,
    responseSchema,
    canWrite,
    method: writeMethod ?? 'PUT',
  });

  const { isReadyToRead, readFn } = useReadFn({
    getUrlFn: getReadUrlFn,
    canRead,
    responseSchema,
  });

  return useReadWritePattern({
    isReadyToWrite,
    writeFn,
    isReadyToRead,
    readFn,
  });
};
